import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSparklesTwo2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sparkles-two-2, ai 2 stars, sparkles, ✨"><path fillRule="evenodd" clipRule="evenodd" d="M12 17.5C15.8194 17.5 17.5 15.8194 17.5 12C17.5 15.8194 19.1806 17.5 23 17.5C19.1806 17.5 17.5 19.1806 17.5 23C17.5 19.1806 15.8194 17.5 12 17.5Z" stroke="currentColor" strokeWidth="1.5"/><path fillRule="evenodd" clipRule="evenodd" d="M1 9C6.55556 9 9 6.55556 9 1C9 6.55556 11.4444 9 17 9C11.4444 9 9 11.4444 9 17C9 11.4444 6.55556 9 1 9Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSparklesTwo2;
